import React, { useEffect, useRef, useState } from 'react';
import { Paper, Box } from '@mui/material';
import { Scrollbars } from 'react-custom-scrollbars-2';

import ArrowTeaser from '../misc/ArrowTeaser';
import UserMessage from '../misc/UserMessage';
import SystemMessage from '../misc/SystemMessage';
import ErrorMessage from '../misc/ErrorMessage';

const ResponseContainer = ({ dataItems, scrollToBottom, setScrollToBottom }) => {
    const scrollbarRef = useRef(null);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    // useEffect(() => {
    // }, [scrollToBottom]);

    useEffect(() => {
        if (scrollbarRef.current && scrollToBottom) {
            const scrollbars = scrollbarRef.current;

            // Scroll to bottom only on new item addition (not initial load)
            if (!isInitialLoad && scrollToBottom) {
                const scrollContentToBottom = () => {
                    const start = scrollbars.getScrollTop();
                    const end = scrollbars.getScrollHeight() - scrollbars.getClientHeight();
                    const duration = 500; // Set a shorter duration for smoother scrolling

                    let startTime = null;

                    const smoothScroll = (currentTime) => {
                        if (!startTime) startTime = currentTime;
                        const timeElapsed = currentTime - startTime;
                        const progress = Math.min(timeElapsed / duration, 1);
                        const ease = easeInOutCubic(progress);

                        scrollbars.scrollTop(start + (end - start) * ease);

                        if (progress < 1) {
                            requestAnimationFrame(smoothScroll);
                        } else {
                            // Set scrollToBottom flag to false after the animation completes
                            setScrollToBottom(false);
                        }
                    };

                    const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

                    requestAnimationFrame(smoothScroll);
                };

                scrollContentToBottom();
            } else {
                // Set scroll to the bottom without animation on initial load
                scrollbars.scrollTop(scrollbars.getScrollHeight());
                setScrollToBottom(false);
            }
        }
    }, [dataItems, scrollToBottom, isInitialLoad]);


    // Triggered after first data load
    useEffect(() => {
        setIsInitialLoad(false);
    }, []);

    if (dataItems.length === 0) {
        return (
            <Scrollbars autoHide>
                <Paper
                    sx={{
                        flexGrow: 1,
                        alignSelf: 'center',
                        width: '100%',
                        height: '100%',
                        borderRadius: 0,
                    }}
                >
                    <ArrowTeaser />
                </Paper>
            </Scrollbars>
        );
    }


    return (
        <Scrollbars autoHide ref={scrollbarRef}>
            <Box
                // elevation={3}
                sx={{
                    flexGrow: 1,
                    backgroundColor: 'background.paper',
                    alignSelf: 'center',
                    borderRadius: 2,
                }}
            >
                {dataItems.map((dataItem, index) => {
                    if (dataItem.isUser) {
                        return <UserMessage key={index} dataItem={dataItem} />;
                    } else if (dataItem.isError) {
                        return <ErrorMessage key={index} dataItem={dataItem} />;
                    } else {
                        return <SystemMessage key={index} dataItem={dataItem} />;
                    }
                })}
            </Box>
        </Scrollbars>
    );
};

export default ResponseContainer;
